import {useQuery, UseQueryResult} from '@tanstack/react-query'
import {api} from '../../../App.global'

export const SITE_POLLING_INTERVAL = 5000
export const SITE_POLLING_MAX_RETRIES = 6

type SiteJSON = {
  lat: string
  lng: string
  siteId: string
  siteNumber: string
  customerId: string
  siteName: string
  street: string
  postalCode: string
  city: string
  state: string
  country: string
  orgUnitId: string
}

export const fetchSite = async (siteId: string): Promise<SiteJSON> => {
  const config = {params: {}}
  const response = await api.get(`/sites/${siteId}`, config)
  const {data} = response
  return data
}

type UsePollSiteByIdOptions = {
  retry?: number
  retryDelay?: number
}

export const usePollSiteById = (
  siteId: string,
  {
    retry = SITE_POLLING_MAX_RETRIES,
    retryDelay = SITE_POLLING_INTERVAL
  }: UsePollSiteByIdOptions = {}
): UseQueryResult<SiteJSON> => {
  const getSite = async (): Promise<SiteJSON> => {
    return await fetchSite(siteId)
  }

  return useQuery<SiteJSON>({
    queryKey: [
      'site',
      {
        siteId
      }
    ],
    queryFn: getSite,
    retry,
    retryDelay
  })
}
